import { useMemo } from 'react';

import { useCacheQuery } from '../../../hooks/use-cache-query';
import {
  GetBulkItemsDocument,
  GetBulkItemsQueryVariables,
} from '../../types/api/graphql';

const useBulkMessageItems = (variables: GetBulkItemsQueryVariables) => {
  const { data: bulkItemsData, loading: bulkItemsDataLoading } = useCacheQuery(
    GetBulkItemsDocument,
    {
      variables: {
        ...variables,
      },
      skip: !variables.healthProviderId,
    }
  );
  const data = useMemo(() => {
    if (bulkItemsData?.bulkCampaigns) {
      return {
        ...bulkItemsData.bulkCampaigns,
        items: bulkItemsData.bulkCampaigns.items ?? [],
      };
    }

    return null;
  }, [bulkItemsData?.bulkCampaigns]);

  return {
    data,
    loading: bulkItemsDataLoading,
  };
};

export { useBulkMessageItems };
